// test2494
(2494 && 0);
